import React, { useEffect, useMemo } from 'react';
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as CheckIcon } from '../images/check-icon.svg'
import GooglePlay from '../images/google-play.png'
import AppStore from '../images/app-store.png'
import { ReactComponent as CryFace } from '../images/cry-icon.svg'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEnachStatusMutation } from '../lib/services/enachApi';
import { useDispatch, useSelector } from 'react-redux';
import { setError } from '../lib/features/kycSlice';
import { openModal, setEnachStatusDetails } from '../lib/features/enachSlice';
import PageHeader from '../components/PageHeader';
import { formatCurrency } from '../lib/middleware/currencyFormatter';
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";
function EnachCongratulations() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [enachStatus] = useEnachStatusMutation()
    const { enachStatusDetails } = useSelector((state) => state.enach);
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const [tapClick] = useTapClickMutation()

    useEffect(() => {
        const getEnachStatus = async () => {
            try {
                let jwt_token
                if (jwt) {
                    jwt_token = jwt
                    localStorage.setItem('jwt', jwt)
                } else {
                    jwt_token = localStorage.getItem('jwt')
                }
                const scrt = secret ? secret : localStorage.getItem('secret')
                const result = await enachStatus({ jwt_token, scrt })
                if (result.data && result.data.status === 'error') {
                    dispatch(setError(result.data.message))
                    dispatch(openModal())
                    if (result.data.message === 'Login expired! Please re-login.') {
                        localStorage.removeItem('jwt');
                        localStorage.removeItem('lastVisitedPage');
                        const phone = localStorage.getItem('phone')
                        localStorage.clear()
                        phone ? navigate(`/?phone=${phone}`) : navigate('/');
                        
                    }
                } else if (result.data && result.data.message === 'Login expired! Please re-login.') {
                    dispatch(openModal())
                    dispatch(setError(result.data.message))
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    
                } else if (result.error) {
                    dispatch(openModal())
                    dispatch(setError('Please check your internet or try again later.'))
                } else {
                    dispatch(setEnachStatusDetails({ ...result.data }))
                    if (result.data.loan_status === 'Approved' || result.data.loan_status === 'approved') {
                        const event_name = 'web_disbursal_congrats_screen'
                        const event_property = { Source: window.localStorage.getItem('utm_source'), segment: result.data.customer_segmentation, reason: result.data.message }
                        await pushCleverTapEvent({ event_name, event_property })
                    }
                    if (result.data.loan_status === 'Rejected' || result.data.loan_status === 'rejected') {
                        const event_name = 'web_onbodring_rejection_screen'
                        const event_property = { Source: window.localStorage.getItem('utm_source'), segment: result.data.customer_segmentation, reason: result.data.message }
                        await pushCleverTapEvent({ event_name, event_property })
                    }
                }
            } catch (error) {
                dispatch(setError('Something went wrong. Please try again later.'));
                dispatch(openModal())
            }
        }
        getEnachStatus()
    }, [dispatch, navigate, enachStatus, jwt, secret])
    return (
        <div className='external-wrapper'>
            <div className='page-content enach-success-page'>
                <PageHeader />
                <div className="approval-content">
                    {enachStatusDetails && (enachStatusDetails.loan_status === 'Approved' || enachStatusDetails.loan_status === 'Loan Closed' || enachStatusDetails.loan_status === 'approved' || enachStatusDetails.loan_status === 'loanclosed') ? <div className="approval-card">
                        <div className="icon-check">
                            <CheckIcon />
                        </div>
                        <h2>Congratulations!</h2>
                        <p>Your loan is ready now!</p>
                        <div className="ticket-box">
                            <p>Loan amount</p>
                            <h1 className="amount">₹{formatCurrency(Number(enachStatusDetails.amount))}</h1>
                            <p className="note">Disbursal is subject to authentication checks on the Stashfin app.</p>
                        </div>
                    </div> : null}
                    {enachStatusDetails && (enachStatusDetails.loan_status === 'Disbursed' || enachStatusDetails.loan_status === 'disbursed') ? <div className="approval-card under-review">
                        <div className="icon-check">
                            <CheckIcon />
                        </div>
                        <h2>Application Submitted</h2>
                        <p>Your application is under review.</p>
                    </div> : null}
                    {enachStatusDetails && (enachStatusDetails.loan_status === 'Rejected' || enachStatusDetails.loan_status === 'rejected' || enachStatusDetails.loan_status === 'Incomplete Application') ? <div className="approval-card failed">
                        <div className="icon-check">
                            <CryFace />
                        </div>
                        {enachStatusDetails.loan_status === 'Rejected' || enachStatusDetails.loan_status === 'rejected' ? <h2>Sorry!</h2> : <h2>Your Application is incomplete</h2>}
                        {enachStatusDetails.loan_status === 'Rejected' || enachStatusDetails.loan_status === 'rejected' ? <><p>We don't have any offers for you currently</p></> : <p>Please complete your application.</p>}
                    </div> : null}

                    <div className="unlock-info">
                        {enachStatusDetails && (enachStatusDetails.loan_status === 'Disbursed' || enachStatusDetails.loan_status === 'Approved') ? <p className='bold-text'>Download Stashfin app to get funds in your bank account</p> : <p className='bold-text'>Download Stashfin app to get funds in your bank account</p>}
                        <div className="logo-links">
                            <StarfinLogo className='logo' />
                            <div className="download-links">
                                <Link to="https://stash.page.link/68s3" target="_blank"><img src={AppStore} alt='App Store' /></Link>
                                <Link to="https://stash.page.link/68s3" target="_blank"><img src={GooglePlay} alt='Play Store' /></Link>
                            </div>
                        </div>
                    </div>
                    <div className='bottom-footer p-0'>
                        {/*<Link to="#" className='partner-link'>Back to partner's page</Link>*/}
                        <button className="btn btn-primary" onClick={() => {
                            //navigate('/complete-your-kyc')
                            window.open('https://stash.page.link/68s3', "_blank")
                        }}>Download App To Get Funds</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EnachCongratulations;
